import React from 'react';
import { useDispatch } from 'react-redux';
import { getReferenceData } from '@/store/actions/category';

export function useFetchReferenceData() {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getReferenceData());
  }, []);
  return [];
}
